import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5H9z"
}), 'CallMadeOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CallMadeOutlined.js
// module id = 2595
// module chunks = 2